import { Loader } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { FindMappingByTypeResponseDto } from "~/gen/api/types"
import { MappingTable } from "~/pages/Admin/Mapping/components/MappingTable"
import { useFindTypeKeysQuery } from "~/pages/Admin/Mapping/hooks/useFindTypeKeysQuery"
import {
  MappingCollapseProps,
  MappingTypeNames,
  Pagination,
} from "~/pages/Admin/Mapping/types"

type Props = MappingCollapseProps & {
  materialTypes: FindMappingByTypeResponseDto["mappings"]
  pagination: Pagination
  search: string
  setSearch: (search: string) => void
}

export const MaterialMapping = ({
  materialTypes,
  pagination,
  search,
  isOpen,
  close,
  open,
  setSearch,
}: Props) => {
  const {
    data: materialTypesList,
    isPending: isLoading,
    isError,
  } = useFindTypeKeysQuery(MappingTypeNames.MATERIAL)
  const { t } = useTranslation()

  if (isLoading) {
    return <Loader />
  }
  if (isError) {
    return (
      <InfoBox
        variant="error"
        title={t("dataLoad.error.title")}
        message={t("dataLoad.error.message")}
      />
    )
  }

  return (
    <MappingTable
      types={materialTypes}
      typesList={materialTypesList.data.map((type) => ({
        ...type,
        deletedAt: type.deletedAt ? new Date(type.deletedAt) : null,
      }))}
      typeName={MappingTypeNames.MATERIAL}
      pagination={pagination}
      search={search}
      setSearch={setSearch}
      isOpen={isOpen}
      close={close}
      open={open}
    />
  )
}
